import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { Segmented } from 'antd';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import { Typography } from '@atoms';

import { Notifications, NotificationWrapper, Divider } from './notification.styles';
import { axiosInstance } from 'utils';
import { useAppDispatch } from 'store';
import { setNewTributeCount } from 'store/slices/profileSlice';
import { toast } from 'react-toastify';

interface INotification {
  name: string,
  user: string,
  type: string,
  date: string,
  uuid: string,
  is_read: boolean,
}

function Notification() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [selectType, setSelectType] = useState(t("all"));
  const [notifications, setNotifications] = useState<INotification[]>([]);

  const firstData = async () => {
    try {
      const formData = new FormData();
      const data = await axiosInstance.get("tribute-notifications/");
      //@ts-ignore
      const formattedData = data.data.results.map(item => ({
        name: item.tribute_to_story.name,
        uuid: item.tribute_to_story.uuid,
        user: item.tribute_creator.username,
        type: "Посвящения",
        date: moment(item.updated_at).format("DD.MM.YYYY"),
        is_read: item.is_read,
      }));

      formData.append("is_read", "true");
      await axiosInstance.patch("tribute-notifications/mark-all-read/", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      dispatch(setNewTributeCount(0))
      setNotifications(formattedData)
    } catch (err) {
      // @ts-ignore
      toast.error(Object.values(err.response.data)[0][0], {
        position: "bottom-right",
        theme: "colored",
      });
    }
  }

  const handleEverythingRead = async () => {
    try {
      const formData = new FormData();

      formData.append("is_read", "true");
      await axiosInstance.patch("tribute-notifications/mark-all-read/", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      dispatch(setNewTributeCount(0))
    } catch (err) {
      // @ts-ignore
      toast.error(Object.values(err.response.data)[0][0], {
        position: "bottom-right",
        theme: "colored",
      });
    }
  }

  useEffect(() => {
    firstData()
  }, [])

  return (
    <NotificationWrapper>
      <div className='notification-title'>
        <Typography as="h4" style={{ color: "#391D0A", marginBottom: "16px" }}>
          {t("notifications")}
        </Typography>
        <Typography
          as="a"
          style={{ color: "#C6A691", marginBottom: "16px", cursor: "pointer" }}
          onClick={handleEverythingRead}
        >
          {t("everythingRead")}
        </Typography>
      </div>
      <Segmented
        value={selectType}
        onChange={setSelectType}
        options={[t("all"), t("tributes"), t("memories")]}
        block
      />
      <Notifications>
        {notifications.map((el, i) => {
          if (selectType === t("all") || selectType === el.type) {
            return (
              <React.Fragment key={i}>
                <div style={{ cursor: "pointer" }} onClick={() => navigate(`/my-stories/${el.uuid}`)}>
                  <Typography>
                    {t("notification1pt")} {el.name} {t("notification2pt")}{" "}
                    {el.user} {t("notification3pt")}{" "}
                    <span style={{ color: "#B29B84" }}>{el.type}</span>!
                  </Typography>
                  <Typography style={{ color: "#89796E", marginTop: "16px" }}>
                    {el.date}
                  </Typography>
                </div>
                {i < notifications.length - 1 && <Divider />}
              </React.Fragment>
            );
          }
          return null;
        })}
      </Notifications>
    </NotificationWrapper>
  )
}

export default Notification
